export const TRAVEL = {
  PRODUCT: 'travel',
  JOURNEY: 'buy',
  SUB_PRODUCT_NAME: 'international_travel',
  COUPON_JOURNEY: 'couponing',
  SEO: 'seo',
};

export enum TravelInsurancePages {
  HOME = 'home',
  SEO = 'travel-insurance',
  TRAVEL_ALL_TRIPS = 'travel_all_trips',
  INT_LANDING_PAGE = 'int_landing_page',
  INT_TRAVEL_FORK_SCREEN = 'int_travel_fork_screen',
  INT_TRAVEL_TRIP_INFO_SCREEN = 'int_travel_trip_info_screen',
  INT_TRAVEL_BUNDLED_PLAN_SELECTION_SCREEN = 'int_travel_bundled_plan_selection_screen',
  INT_TRAVEL_BUNDLED_ADDON_SCREEN = 'int_travel_bundled_add_on_screen',
  INT_TRAVEL_REVIEW_SCREEN = 'int_travel_review_screen',
  INT_TRAVEL_UNBUNDLED_MEDICAL_COVER = 'int_travel_unbundled_medical_cover',
  INT_TRAVEL_UNBUNDLED_TRIP_COVER = 'int_travel_unbundled_trip_cover',
  INT_TRAVEL_UNBUNDLED_BAGGAGE_COVER = 'int_travel_unbundled_baggage_cover',
  INT_TRAVEL_ADD_COVER_NUDGE_MODAL = 'int_travel_add_cover_nudge_modal',
  INT_TRAVEL_ADD_ON_NUDGE_MODAL = 'int_travel_add_on_nudge_modal',
  INT_TRAVEL_MEDICAL_INSURANCE_MANDATORY_MODAL = 'int_travel_medical_insurance_mandatory_modal',
  INT_TRAVEL_MEDICAL_COVER_PERSUASION_MODAL = 'int_travel_medical_cover_persuasion_modal',
  INT_TRAVEL_TRIP_COVER_PERSUASION_MODAL = 'int_travel_trip_cover_persuasion_modal',
  INT_TRAVEL_BAGGAGE_COVER_PERSUASION_MODAL = 'int_travel_baggage_cover_persuasion_modal',
  INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_SCREEN = 'int_travel_post_payment_add_details_screen',
  INT_TRAVEL_POST_PAYMENT_ADD_DETAILS_NUDGE = 'int_travel_post_payment_add_details_nudge',
  INT_TRAVEL_TRAVELLERS_DETAILS_SCREEN = 'int_travel_travellers_details_screen',
  INT_TRAVEL_BUY_JOURNEY_SUCCESS_SCREEN = 'int_travel_buy_journey_success_screen',
  INT_TRAVEL_POST_PAYMENT_DOWNLOAD_APP = 'int_travel_post_payment_download_app',
  INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS = 'int_travel_post_payment_travellers_details',
  INT_TRAVEL_HELP_SCREEN = 'int_travel_help_screen',
  INT_TRAVEL_PAYMENT_PENDING_SCREEN = 'int_travel_payment_pending_screen',
  INT_TRAVEL_VERIFY_PAYMENT_SCREEN = 'int_travel_verify_payment_screen',
  INT_TRAVEL_COUPON_LIST = 'int_travel_coupon_list',
  INT_TRAVEL_WIDGET_HT = 'int_travel_widget_ht',
  INT_TRAVEL_PAYMENT_INITIATION_LOADER = 'int_travel_payment_initiation_loader',
  INT_TRAVEL_POST_PAYMENT_TRAVELLERS_DETAILS_SCREEN = 'int_travel_post_payment_travellers_details_screen',
  INT_LANDING_PAGE_COVERAGE_EXPLAINER = 'int_landing_page_coverage_explainer',
  INT_LANDING_PAGE_CLAIMS_EXPLAINER = 'int_landing_page_claims_explainer',
  INT_LANDING_PAGE_FLEXIBILITY_SECTION = 'int_landing_page_flexibility_section',
  INT_LANDING_PAGE_CUSTOMER_SUPPORT_SECTION = 'int_landing_page_customer_support_section',
  INT_LANDING_PAGE_TESTIMONIAL_SECTION = 'int_landing_page_testimonial_section',
  INT_LANDING_PAGE_FAQ_SECTION = 'int_landing_page_faq_section',
  INT_TRIP_INFO_PAGE = 'int_trip_info_page',
}

export enum TravelInsuranceViewEvents {
  VIEW_INT_LANDING_PAGE = 'view_int_landing_page',
  VIEW_INT_TRIP_INFO_SCREEN = 'view_int_trip_info_screen',
  VIEW_PAGE_INT_FORK_SCREEN = 'view_page_int_fork_screen',
  VIEW_PAGE_INT_TRIP_INFO_SCREEN = 'view_page_int_trip_info_screen',
  VIEW_PAGE_INT_BUNDLED_PLAN = 'view_page_int_bundled_plan',
  VIEW_PAGE_INT_BUNDLED_ADD_ON = 'view_page_int_bundled_add_on',
  VIEW_PAGE_INT_REVIEW = 'view_page_int_review',
  VIEW_INT_PAGE_PAYMENT_SUCCESS = 'view_int_page_payment_success',
  VIEW_INT_PAGE_POST_PAYMENT_DETAILS_PENDING = 'view_int_page_post_payment_details_pending',
  VIEW_PAGE_INT_MEDICAL_COVER = 'view_page_int_medical_cover',
  VIEW_PAGE_INT_TRIP_COVER = 'view_page_int_trip_cover',
  VIEW_PAGE_INT_BAGGAGE_COVER = 'view_page_int_baggage_cover',
  VIEW_MODAL_INT_ADD_COVER_NUDGE = 'view_modal_int_add_cover_nudge',
  VIEW_MODAL_INT_ADD_ON_NUDGE = 'view_modal_int_add_on_nudge',
  VIEW_MODAL_INT_MEDICAL_INSURANCE_MANDATORY_NUDGE = 'view_modal_int_medical_insurance_mandatory_nudge',
  VIEW_MODAL_INT_COVER_PERSUASION = 'view_modal_int_cover_persuasion',
  VIEW_PAGE_INT_TRAVELLERS_DETAILS = 'view_page_int_travellers_details',
  VIEW_MODAL_INT_PRICE_UPDATE = 'view_modal_int_price_update',
  VIEW_MODAL_INT_COVERAGE_UPDATE = 'view_modal_int_coverage_update',
  VIEW_MODAL_INT_TRAVELLER_AGE_UPDATE = 'view_modal_int_traveller_age_update',
  VIEW_PAGE_INT_BUY_JOURNEY_SUCCESS = 'view_page_int_buy_journey_success',
  VIEW_PAGE_INT_POST_ISSUANCE_DOWNLOAD_APP = 'view_page_int_post_issuance_download_app',
  VIEW_PAGE_PAYMENT_SUCCESS_ADD_DETAILS = 'view_page_payment_success_add_details',
  VIEW_PAGE_INT_HELP = 'view_page_int_help',
  VIEW_PAGE_INT_PAYMENT_PENDING = 'view_page_int_payment_pending',
  VIEW_PAGE_INT_ERROR = 'view_page_int_error',
  VIEW_PAGE_INT_COUPON_LIST = 'view_page_int_coupon_list',
  VIEW_PAGE_INT_COUPON_APPLIED = 'view_page_int_coupon_applied',
  VIEW_PAGE_INT_PAYMENT_INITIATION = 'view_page_int_payment_initiation',
  VIEW_COUPON_NUDGE = 'view_coupon_nudge',
  VIEW_COUPON_SCROLL = 'view_coupon_scroll',
  VIEW_TRAVEL_WIDGET_HT = 'view_travel_widget_ht',
  VIEW_PAGE_CIS_CONFIRMATION = 'view_page_cis_confirmation',
  VIEW_PAGE_INT_TRAVELLERS_DETAILS_POST_PAYMENT = 'view_page_int_travellers_details_post_payment',
  VIEW_PAGE_ALL_TRIPS = 'view_page_all_trips',
  VIEW_COUNTRY_DETAIL_CARD = 'view_country_detail_card',
  VIEW_TRAVELLER_COUNT_CARD = 'view_traveller_count_card',
  VIEW_TRIP_DURATION_CARD = 'view_trip_duration_card',
  VIEW_FORK_SCREEN_CARD = 'view_fork_screen_card',
  VIEW_OTHER_PLANS_COMPARISON = 'view_other_plans_comparison',
}

export enum TravelInsuranceTrackEvents {
  TAP_BTN_INT_HELP = 'tap_btn_int_help',
  TAP_BTN_INT_BACK = 'tap_btn_int_back',
  TAP_BTN_INT_PRICE_BREAKUP_DETAILS = 'tap_btn_int_price_breakup_details',
  TAP_BTN_INT_EDIT_DETAILS = 'tap_btn_int_edit_details',
  TAP_BTN_INT_CONTINUE = 'tap_btn_int_continue',
  TAP_BTN_INT_BUNDLED_JOURNEY = 'tap_btn_int_bundled_journey',
  TAP_BTN_INT_UNBUNDLED_JOURNEY = 'tap_btn_int_unbundled_journey',
  TAP_BTN_INT_BUNDLED_BASIC_PLAN_BENEFITS = 'tap_btn_int_bundled_basic_plan_benefits',
  TAP_BTN_INT_BUNDLED_COMFORT_PLAN_BENEFITS = 'tap_btn_int_bundled_comfort_plan_benefits',
  TAP_BTN_INT_BUNDLED_COMPARE = 'tap_btn_int_bundled_compare',
  TAP_BTN_INT_BUNDLED_PLAN = 'tap_btn_int_bundled_plan',
  TAP_BTN_INT_SELECT_ADD_ON = 'tap_btn_int_select_add_on',
  TAP_BTN_INT_ADD_DETAILS = 'tap_btn_int_add_details',
  TAP_BTN_INT_SKIP = 'tap_btn_int_skip',
  TAP_BTN_INT_TRIP_INFO_CONTINUE = 'tap_btn_int_trip_info_continue',
  TAP_BTN_INT_SEE_BENEFITS = 'tap_btn_int_see_benefits',
  TAP_BTN_INT_ADD_ON_TOGGLE = 'tap_btn_int_add_on_toggle',
  TAP_BTN_INT_ADD_COVER = 'tap_btn_int_add_cover',
  TAP_BTN_INT_SKIP_COVER = 'tap_btn_int_skip_cover',
  TAP_BTN_INT_UPDATE_COVERAGE_AMOUNT = 'tap_btn_int_update_coverage_amount',
  TAP_BTN_INT_VIEW_POLICY = 'tap_btn_int_view_policy',
  TAP_BTN_INT_DOWNLOAD_APP = 'tap_btn_int_download_app',
  TAP_BTN_INT_COPY_NOMINEE = 'tap_btn_int_copy_nominee',
  TAP_BTN_INT_CTA = 'tap_btn_int_cta',
  TAP_BTN_INT_SUM_INSURED_UPDATE = 'tap_btn_int_sum_insured_update',
}

export const VAS = {
  JOURNEY: 'visa assistance',
  SUB_PRODUCT_NAME: 'visa_assistance',
  SERVICE: 'visa2fly',
  VAS_ROUTER_QUERY: 'vasQuery',
  VAS_HISTORY_REFERER: 'vasReferer',
  VAS_MY_BOOKING_REFERER: 'vasMyBookingsReferer',
  VAS_RESUME_BOOKING_REFERER: 'vasResumeBookingReferer',
};

export const DOMESTIC_PASS = {
  JOURNEY: 'buy',
  SUB_PRODUCT_NAME: 'travel_pass',
};

export enum VasPages {
  TRAVEL_HOMEPAGE = 'travel_homepage',
  EXPLORE_PAGE = 'explore_page',
  TRAVEL_VISA_POST_PAYMENT_INSURANCE_NUDGE = 'travel_visa_post_payment_insurance_nudge',
  VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION = 'view_modal_visa_assistance_country_selection',
  TRAVEL_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE = 'travel_visa_assistance_country_selection_page',
  TRAVEL_VISA_REDIRECTION_LOADER = 'travel_visa_redirection_loader',
  TRAVEL_VISA_APPLICATION_SUCCESS = 'travel_visa_application_successful',
  TRAVEL_VISA_PAYMENT_INITIATION_LOADER = 'travel_visa_payment_initiation_loader',
  TRAVEL_VISA_PAYMENT_VERIFICATION_LOADER = 'travel_visa_payment_verification_loader',
}

export enum VasViewEvents {
  VIEW_PAGE_EXPLORE = 'view_page_explore',
  VIEW_PAGE_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE = 'view_page_visa_assistance_country_selection_page',
  VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION = 'view_modal_visa_assistance_country_selection',
  VIEW_PAGE_VISA_REDIRECTION_LOADER = 'view_page_visa_redirection_loader',
  VIEW_PAGE_VISA_APPLICATION_SUCCESSFUL = 'view_page_visa_application_successful',
  VIEW_PAGE_VISA_ASSISTANCE_TRAVEL_INSURANCE_NUDGE = 'view_page_visa_assistance_travel_insurance_nudge',
  VIEW_PAGE_VISA_ASSISTANCE_PAYMENT_INITIATION = 'view_page_visa_assistance_payment_initiation',
  VIEW_PAGE_VISA_ASSISTANCE_PAYMENT_VERIFICATION = 'view_page_visa_assistance_payment_verification',
}

export enum VasTrackEvents {
  TAP_BTN_COUNTRY_SELECTION = 'tap_btn_country_selection',
  TAP_BTN_INT_CONTINUE = 'tap_btn_int_continue',
  TAP_BTN_COUNTRY_SEARCH_FILTER = 'tap_btn_country_search_filter',
  TAP_BTN_COUNTRY_SEARCH = 'tap_btn_country_search',
  TAP_BTN_INT_SKIP = 'tap_btn_int_skip',
}

export enum TravelPassPages {
  TRAVEL_HOMEPAGE = 'travel_homepage',
  FLIGHT_PASS_LANDING_PAGE = 'flight_pass_landing_page',
  FLIGHT_PASS_LANDING_PAGE_BUY_MODAL = 'flight_pass_landing_page_buy_modal',
  FLIGHT_PASS_POST_PAYMENT_ADDRESS_SETUP_PAGE = 'flight_pass_post_payment_address_setup_page',
  FLIGHT_PASS_PAYMENT_INITIATED_PAGE = 'flight_pass_payment_initiated_page',
  FLIGHT_PASS_PAYMENT_PROCESSING_PAGE = 'flight_pass_payment_processing_page',
  FLIGHT_PASS_PAYMENT_SUCCESS_PAGE = 'flight_pass_payment_success_page',
  FLIGHT_PASS_PAYMENT_FAILED_PAGE = 'flight_pass_payment_failed_page',
  FLIGHT_PASS_POLICY_INIT_PAGE = 'flight_pass_policy_init_page',
  FLIGHT_PASS_POLICY_SUCCESS_PAGE = 'flight_pass_policy_success_page',
  FLIGHT_PASS_SAVED_ADDRESSES_MODAL = 'flight_pass_saved_addresses_modal',
  FLIGHT_PASS_ADD_NEW_ADDRESS_MODAL = 'flight_pass_add_new_address_modal',
  FLIGHT_PASS_ADDRESS_SAVED_PAGE = 'flight_pass_address_saved_page',
  FLIGHT_PASS_APP_DOWNLOAD_PAGE = 'flight_pass_app_download_page',
}

export enum TravelPassViewEvents {
  VIEW_PAGE_FLIGHT_PASS_LANDING_SCREEN = 'view_page_flight_pass_landing_screen',
  VIEW_MODAL_FLIGHT_PASS_USER_DETAILS = 'view_modal_flight_pass_user_details',
  VIEW_PAGE_FLIGHT_PASS_PAYMENT_SUCCESS = 'view_page_flight_pass_payment_success',
  VIEW_PAGE_FLIGHT_PASS_ADDRESS_NUDGE = 'view_page_flight_pass_address_nudge',
  VIEW_MODAL_FLIGHT_PASS_SAVED_ADDRESSES = 'view_modal_flight_pass_saved_addresses',
  VIEW_MODAL_FLIGHT_PASS_ADD_NEW_ADDRESS = 'view_modal_flight_pass_add_new_address',
  VIEW_PAGE_FLIGHT_PASS_ADDRESS_ADDED = 'view_page_flight_pass_address_added',
  VIEW_PAGE_FLIGHT_PASS_APP_DOWNLOAD_NUDGE = 'view_page_flight_pass_app_download_nudge',
  VIEW_PAGE_FLIGHT_PASS_SET_UP_COMPLETE = 'view_page_flight_pass_set_up_complete',
}

export enum TravelPassTrackEvents {
  TAP_BTN_CONTINUE = 'tap_btn_continue',
  TAP_BTN_INT_BACK = 'tap_btn_back',
}

export const EventType = {
  TAP: 'tap',
  VIEW: 'view',
};

export enum AppsFlyerEvents {
  INT_LEAD_ENTERED = 'int_lead_entered',
  INT_QUOTE_GENERATED_BUNDLED = 'int_quote_generated_bundled',
  INT_QUOTE_GENERATED_UNBUNDLED = 'int_quote_generated_unbundled',
  INT_PAYMENT_COMPLETED = 'int_payment_completed',
}

export enum AppsFlyer {
  ACTION = 'send_event',
  DESTINATION = 'firebase',
}

export const HindustanTimesPartner = {
  action: 'advLPClick',
  type: { leadSubmit: 'leadSubmit', buttonClick: 'buttonClick' },
  campaign: 'AckoTravelInsurance',
  source: 'ht',
  medium: 'display',
  event: 'event',
  pages: {
    tripInfo: 'tripInfo',
    bundledPlan: 'bundledPlan',
    bundledAddon: 'bundledAddon',
    unbundledPlan: 'unbundledPlan',
    travellersDetails: 'travellersDetails',
    checkout: 'checkout',
    paymentSuccess: 'paymentSuccess',
  },
};
